import SearchBlock from '@insurancemenu/imenu-components-lib/dist/components/SearchBlock';
import { Button, Collapse, colors, IMForm } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils';
import SubsectionTitle from 'components/common/general/SubsectionTitle';

export const IMFormStyled = styled(IMForm)`
  max-width: none;
  width: 100%;
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  box-sizing: border-box;
  padding: 4rem 10rem 8rem;
  margin: 0;

  ${breakpointsMQ4.lg.down} {
    padding: 4rem 4rem 8rem;
  }
`;

export const ToggleDetailsButtonStyled = styled(Button)`
  padding-left: 0;
  margin: 1rem 0;
  width: 100%;
  justify-content: flex-start;
  text-align: left;
`;

export const SearchBlockStyled = styled(SearchBlock)`
  width: 100%;
`;

export const FollowingSubsectionTitleStyled = styled(SubsectionTitle)`
  margin: 2rem 0 0;
`;

export const SubsectionTitleStyled = styled(SubsectionTitle)`
  margin: 0;
`;

export const CollapseStyled = styled(Collapse)`
  width: 100%;
`;

// Matches the IMForm layout styles. The Collapse component cannot be used as a flex container
export const AdditionalDetailsWrapperStyled = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-flow: wrap;
  gap: 3rem 2rem;
  max-width: none;
  width: 100%;
`;
